import { useEffect } from 'react';

import { LANGUAGE_SETTINGS_CHANGE_CHANNEL } from 'src/constants/i18n.constants';
import { LanguageSettingsMessage } from 'src/interfaces/i18n.types';
import authService from 'src/services/api/auth.service';
import { useGetLanguageStateQuery } from 'src/store/api/client-state';
import { handleLanguageChange } from 'src/utils/i18n.utils';

export const useCurrentLanguageTranslation = () => {
  const userBk = authService.getUserBk();

  const { data: languageState, isLoading } = useGetLanguageStateQuery(userBk);

  // load translation on app start
  useEffect(() => {
    if (isLoading) return;

    handleLanguageChange(languageState);
  }, [isLoading, languageState]);

  // load translation when language settings have changed
  useEffect(() => {
    const handleLanguageSettingsChange = (
      event: MessageEvent<LanguageSettingsMessage>,
    ) => {
      handleLanguageChange(event.data);
    };

    const channel = new BroadcastChannel(LANGUAGE_SETTINGS_CHANGE_CHANNEL);

    channel.addEventListener('message', handleLanguageSettingsChange);

    return () => {
      channel.close();
    };
  }, []);
};
